"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateFlatGatewayData = exports.getFlatGatewayData = void 0;
const getFlatGatewayData = (gatewayData) => {
    const { gatewayLocation, deviceLocation, ...gatewayDataOthers } = gatewayData;
    const { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } = gatewayLocation ?? {};
    const { lat: deviceLat, lng: deviceLng, DOP: deviceDOP } = deviceLocation ?? {};
    const flatRecord = {
        ...gatewayDataOthers,
        deviceLat,
        deviceLng,
        deviceDOP,
        gatewayLat,
        gatewayLng,
        gatewayDOP,
    };
    return flatRecord;
};
exports.getFlatGatewayData = getFlatGatewayData;
const hydrateFlatGatewayData = (flatData) => {
    const { deviceLat, deviceLng, deviceDOP, gatewayLat, gatewayLng, gatewayDOP, ...gatewayDataOthers } = flatData;
    const deviceLocation = deviceLat && deviceLng ? { lat: deviceLat, lng: deviceLng, DOP: deviceDOP } : undefined;
    const gatewayLocation = gatewayLat && gatewayLng ? { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } : undefined;
    const res = {
        ...gatewayDataOthers,
        gatewayLocation,
        deviceLocation,
    };
    return res;
};
exports.hydrateFlatGatewayData = hydrateFlatGatewayData;
